import { gql } from '~gql-types/gql'

export const ARCHIVE_BOARD = gql(`
  mutation archiveBoard($boardId: ID!) {
    archiveBoard(boardId: $boardId) {
      ...BoardFields
    }
  }
`)

export const UNARCHIVE_BOARD = gql(`
  mutation unarchiveBoard($boardId: ID!) {
    unarchiveBoard(boardId: $boardId) {
      ...BoardFields
    }
  }
`)

export const ARCHIVED_BOARD = gql(`
  query archivedBoard($boardId: ID!) {
    findBoard(id: $boardId) {
      id
      title
      ltiIds
      lti3Integrations {
        id
      }
      archivedBy {
        __typename
        ... on BoardMember {
          boardId
          role
          userId
          user {
            avatar
            firstname
            followees {
              followeesCount
            }
            followers {
              followersCount
            }
            followsUser
            id
            lastname
            legacyEid
            profilePhotoUrl
            username
          }
        }
        ... on BoardViewer {
          userId
          boardId
          user {
            avatar
            firstname
            followees {
              followeesCount
            }
            followers {
              followersCount
            }
            followsUser
            id
            lastname
            legacyEid
            profilePhotoUrl
            username
          }
        }
      }
      archivedAt
      owner {
        id
        firstname
        lastname
        username
        avatar
        legacyEid
        profilePhotoUrl
        followsUser
        followers {
          followersCount
        }
        followees {
          followeesCount
        }
      }
      network {
        id
        title
        name
      }
      loggedInBoardUser {
        __typename
        ... on BoardMember {
          role
          boardId
          userId
          user {
            id
            firstname
            lastname
            username
            avatar
            legacyEid
            profilePhotoUrl
          }
        }
        ... on BoardViewer {
          boardId
          userId
          user {
            id
            firstname
            lastname
            username
            avatar
            legacyEid
            profilePhotoUrl
          }
        }
      }
    }
  }
`)
